/*
 * @Author: your name
 * @LastEditors: yang chenglin
 * @Description: In User Settings Edit
 */
import React, { useEffect, useState } from 'react';
import { Button, Table, Select, Balloon, Radio } from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';
import LzPagination from '@/components/common/LzPagination';
import { CanvasService } from '@/service';
import LzMsg from '@/components/common/LzMsg';
import LzDialog from '@/components/common/LzDialog';
import SecondaryMarketCrowd from '@/components/crowd/SecondaryMarketCrowd';
import BatchSecondaryMarket from '@/components/crowd/BatchSecondaryMarket';
import PageUtils from '../../../utils';
import phone from '@/assets/images/CanvasImages/phone.png';
import head from '@/assets/images/CanvasImages/head.png';
import utils from '@/common/utils';

const { Tooltip } = Balloon;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const imgAuto = [
  '//img10.360buyimg.com/imgzone/jfs/t1/157756/6/852/1042/5fed6b0fEeb023d51/7407eb9f243ba76e.png',
  '//img10.360buyimg.com/imgzone/jfs/t1/143190/2/19310/907/5fe0724bE043681c8/0a9d35184d4aac73.png',
];

// 执行状态
const executionStatus = {
  1: '平台侧系统审核中',
  3: '审核通过',
  4: '驳回',
  5: '停止投放',
  100: '投放中',
  101: '投放成功',
  102: '投放失败',
  // 103: '投放成功',
  // 104: '投放成功',
};
export default (props) => {
  const [loading, setLoading] = useState(false);
  // 任务类型  是否是单次
  const [isSingle, setIsSingle] = useState(true);

  // 批量导出列表
  const [exportList, setExportList] = useState([]);
  // 表格数据
  const [tableData, setTableData] = useState([]);
  // 循环次数
  const [cycleTimes, setCycleTimes] = useState();

  // 是否显示 生成二次营销人群
  const [secondaryVisible, setSecondaryVisible] = useState(false);
  const [secondaryMarketCrowdData, setSecondaryMarketCrowdData] = useState();
  // 批量二次营销弹窗visible
  const [batchSecondaryVisible,setBatchSecondaryVisible] = useState(false);
  // 批量二次营销按钮禁用状态
  const [secondaryMarketCrowdBtn,setSecondaryMarketCrowdBtn] = useState(false);
  // 二次营销子组件关闭
  const secondaryClose = () => {
    setSecondaryVisible(false);
  };

  const [checkedKeys, setCheckedKeys] = useState('');
  // 被选的报表的taskInstId
  const [chartKeys, setChartKeys] = useState([]);
  // 被选的报表的id
  const [chartKeysId, setChartKeysId] = useState([]);
  //被勾选的全部信息
  const [checkedInfo,setCheckedInfo] = useState([]);
  // 分页
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 数据导出
  const dataExport = (params) => {
    if(tableData.length === 0) {
      LzMsg.warning('暂无数据导出');
      return
    };
    CanvasService.testDetailExport({ activityId: params })
      .then((res) => {
        utils.downloadFile(res);
        if (res.success) {
          LzMsg.success('数据导出成功');
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // stopSmsTask 短信任务活动停止
  const stopSmsSendTask = (id, type) => {
    CanvasService.stopSmsTask({ activityRecordId: id, type: type })
      .then((res) => {
        LzMsg.success('停止成功');
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const searchList = (params) => {
    setLoading(true);
    CanvasService.getCanvasNodeData(params)
      .then((res) => {
        let temp = res.data;
        if(params.canvasTaskType === 8) {
            temp = res.data.map((e) => {
                return {
                  ...e,
                  smsContent: e.smsContent ? {
                    ...JSON.parse(e.smsContent),
                    tplData: (+JSON.parse(e.smsContent).type === 2 || +JSON.parse(e.smsContent).type === 1) ?
                    JSON.parse(JSON.parse(e.smsContent).tplData) : +JSON.parse(e.smsContent).type === 5 ?
                    JSON.parse(e.smsContent).tplData :
                      {}
                  } : {},

                }
              })
        }
        // 赋值
        setTableData(temp);
        // 设置翻页
        setPageInfo({
          ...pageInfo,
          total: res.page.total,
          pageNo: res.page.pageNo,
          pageSize: res.page.pageSize,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // 翻页

  const handlePageSizeChange = async (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      searchList({
        ...props.formParams,
        pageSize: pages.pageSize,
        pageNo: pages.pageNo,
      });
    } catch (e) {
      // LzMsg.error(e.message);
    }
  };


  useEffect(() => {
    // if(props.paramKey){
    searchList({
      ...props.formParams,
      pageSize: 10,
      pageNo: 1,
    });
    // }
  }, [props.formParams]);

  return (
    <div className={styles.container}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '15px',
          marginTop: '20px',
        }}
      >
        {/* <div style={{ height: '28px', lineHeight: '28px' }}>
          已选择
          <span
            style={{
              color: '#FF3333',
              paddingLeft: '5px',
              paddingRight: '5px',
            }}
          >
            {chartKeys.length}
          </span>
          项
          <span
            style={{
              color: 'rgb(51, 153, 255)',
              marginLeft: '10px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setChartKeys([]);
              setChartKeysId([]);
              setCheckedInfo([]);
            }}
          >
            清空
          </span>
        </div> */}

        {/* <div className={styles['flex-start-center']}> */}
        <div style={{
          width: '100%',
          textAlign:'right'
        }}>
          {/* {
            (+props.formParams.canvasTaskType === 4 || +props.formParams.canvasTaskType === 5 ) &&
            <Button
              type="secondary"
              style={{ marginLeft: '10px', width: '88px', padding: 0 }}
              className={styles.btn}
              disabled={secondaryMarketCrowdBtn}
              onClick={() => {
                if (checkedInfo.length === 0) {
                  LzMsg.error('请选择要二次营销的任务');
                } else {
                  setBatchSecondaryVisible(true);
                }
              }}
            >
              批量二次营销
            </Button>
          } */}
          <Button
            type="primary"
            style={{ marginLeft: '20px', width: '88px', padding: 0 }}
            className={styles.btn}
            onClick={() => {
            // 20230518需求变更，导出直接变为全部导出，不与多选相关联
            //   if (chartKeysId.length === 0) {
            //     LzMsg.error('请选择要导出的任务');
            //   } else {
                // dataExport(chartKeysId);
                  dataExport(props.formParams.campaignId);
            //   }
            }}
          >
            全部导出
          </Button>
          <Balloon.Tooltip align="t" trigger={<span style={{fontSize: '20px',marginLeft: '5px'}} className='iconfont icon-icon4-33' />}>
            <>将当前节点报表全部导出</>
          </Balloon.Tooltip>
        </div>
      </div>
      <div>
        <Table.StickyLock
          dataSource={tableData}
          // fixedHeader maxBodyHeight={(window.screen.height) * 0.6 - 170}
          loading={loading}
          // rowSelection={{
          //   selectedRowKeys: chartKeys,
          //   // args 数组的0项是值  1 项是数据对象
          //   onChange: (args,records) => {
          //     //获得当前勾选的全部数据
          //     let newCheckedInfo = [...checkedInfo]
          //     tableData.forEach((item,index)=>{//遍历当前页列表
          //         if(args.indexOf(item.taskInstId) > -1) {//如果已勾选
          //           newCheckedInfo.push({
          //             ...item,
          //             crowdName:`${item.taskName}-二次营销-${Math.random().toString().substring(2,8)}`
          //           })
          //         }else {//如果未勾选
          //           newCheckedInfo.forEach((item1,index1)=>{ //遍历newCheckedInfo
          //             if(item1.taskInstId===item.taskInstId){ //如果newCheckedInfo里有未勾选的
          //               newCheckedInfo.splice(index1,1) //删除该条数据
          //             }
          //           })
          //         }
          //     })
          //     //去重
          //     newCheckedInfo = newCheckedInfo.filter((currentValue, currentIndex, selfArr)=>{
          //       return selfArr.findIndex(x=>x.taskInstId===currentValue.taskInstId)===currentIndex
          //     })
          //      //获得当前全部数据的状态
          //      let campaignStateArr= [];
          //      newCheckedInfo.forEach((item,index)=>{
          //        campaignStateArr.push(+item.packStatus);
          //      })
          //      //如果有状态有不等于投放成功的就禁用批量二次营销按钮
          //      campaignStateArr = [...Array.from(new Set(campaignStateArr))];
          //      if(campaignStateArr.length===0
          //         ||campaignStateArr.length===1&&campaignStateArr[0]===103
          //         ||campaignStateArr.length===1&&campaignStateArr[0]===104
          //         ||(campaignStateArr.length===2&&campaignStateArr[0]===103&&campaignStateArr[0]===104)
          //         ||(campaignStateArr.length===2&&campaignStateArr[0]===104&&campaignStateArr[0]===103)
          //         ){
          //        setSecondaryMarketCrowdBtn(false);
          //      }else{
          //        setSecondaryMarketCrowdBtn(true);
          //      }
          //     // 改变选中list的值
          //     setChartKeys(args);
          //     setChartKeysId(records.filter(item => args.indexOf(item.taskInstId) > -1).map(x => x.id));
          //     setCheckedInfo(newCheckedInfo);
          //   },
          //   // getProps: record => {
          //   //   return {
          //   //     disabled: record.packStatus !== 103 || record.packStatus !== 104
          //   //   };
          //   // }
          // }}
          // primaryKey="taskInstId"
          style={{ overflowX: 'auto', width: '100%' }}
        >
          {/* <Table.Column title={<div>
            <span>节点名称</span>
            <Tooltip align="t" trigger={<span style={{ fontSize: "14px", marginLeft: "4px", cursor: "pointer" }} className={`iconfont icon-icon4-33`}></span>}>
              节点名称-循环次数
            </Tooltip>
          </div>} align='left' dataIndex="taskName" width="150px"/> */}
          <Table.Column
            align="left"
            width="100px"
            title="节点名称"
            dataIndex="taskName"
          />
          {/* <Table.Column
            align="left"
            width="100px"
            title="循环次数"
            dataIndex="cycleIndex"
          />
          <Table.Column
            align="left"
            width="100px"
            title="营销类型"
            dataIndex="taskType"
            cell={(value, index, item) =>
              (
                <div>{PageUtils.nodeType.find(item => item?.value === +value)?.label ?? '/'}</div>
              )
            }
          />
          {!isSingle && (
            <Table.Column
              align="left"
              title="循环次数"
              dataIndex="cycleNum"
              width="100px"
            />
          )} */}
          <Table.Column
            align="left"
            title="执行时间"
            cell={(value, index, item) => (
              <div>
                {moment(Number(item.launchTime)).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            )}
            width="150px"
          />
          <Table.Column
            align="left"
            title="预计投放人数"
            cell={(value, index, item) => (
              <div>{item.expectSendAmount.toLocaleString()}</div>
            )}
            width="100px"
          />
          <Table.Column
            align="left"
            title="实际投放人数"
            cell={(value, index, item) => (
              <div>
                {item.sendSuccessValue > 0
                  ? item.sendSuccessValue.toLocaleString()
                  : '/'}
              </div>
            )}
            width="100px"
          />
          <Table.Column
            align="left"
            title="任务状态"
            cell={(value, index, item) => (
              <div>
                {
                    item.taskType === 1 ? '/' :
                    item.pre == 1 ? (
                    <div>
                        {/* {item.packStatus} */}
                        {executionStatus[item.packStatus]}
                    </div>
                    ) : (
                    <div>预执行</div>
                    )
                }
              </div>
            )}
            width="110px"
          />
          <Table.Column
            align="left"
            title="投放内容"
            cell={(value, index, item) =>
              item.taskType === 8 ? (
                <Balloon
                    v2
                    trigger={<Button text type="primary">点击查看详情</Button>}
                    align="r"
                    triggerType="click"
                    title={false}
                    style={{ width: 300 }}
                >
                    {/* 手机效果 */}
                    <div className={styles.phoneBlock}>
                        <div className={styles.phone}>
                        <img src={phone} />
                        {/* 純文本手机效果 */}
                        {+item.smsContent.type === 5 && (
                            <div className={styles.textContainer}>
                            <div className={styles.textDate}>
                                <span>10月20日</span>
                            </div>
                            <div className={styles.textContext}>
                                <img className={styles.textHead} src={head} />
                                <div className={styles.textRight}>
                                <div className={styles.textName}>XXX客服</div>
                                <div
                                    id="textWord"
                                    className={styles.textBox}
                                    dangerouslySetInnerHTML={{
                                    __html: item.smsContent.tplData || '<div>文本</div>',
                                    }}
                                >
                                </div>
                                </div>
                            </div>
                            </div>
                        )}
                        {/* 商品卡片手机效果 */}
                        {+item.smsContent.type == 1 && item.smsContent.tplData.showType == 1 && (
                            <div className={styles.textContainer}>
                            <div className={styles.textDate}>
                                <span>10月20日</span>
                            </div>
                            <div className={styles.textContext}>
                                <img className={styles.textHead} src={head} />
                                <div className={styles.textRight}>
                                <div className={styles.textName}>XXX客服</div>
                                <div className={styles.textCardContext}>
                                    <div className={styles.textCardTitle}>
                                    {item.smsContent.tplData.title || '标题'}
                                    </div>
                                    <div className={styles.textCardmain}>
                                    {item.smsContent.tplData.message || '邀请语'}
                                    </div>
                                    <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        flexWrap: 'wrap',
                                    }}
                                    >
                                    {item.smsContent.tplData.data.length > 0 &&
                                        item.smsContent.tplData.data.map((item, index) => (
                                        <div key={index}>
                                            <img
                                            key={index}
                                            style={{ height: 72 }}
                                            src={item.imagePath}
                                            alt=""
                                            />
                                            <div>
                                            {/* ¥{(+item.price).toFixed(2)} */}
                                            ¥{item.price}
                                            </div>
                                        </div>
                                        ))}
                                    </div>
                                    {item.smsContent.tplData.bottomBtnType === '1' && (
                                    <div
                                        style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginTop: '10px',
                                        }}
                                    >
                                        <span style={{ marginRight: '5px' }}>
                                        查看更多
                                        </span>
                                        <img
                                        src="//img10.360buyimg.com/imgzone/jfs/t1/145928/2/19396/367/5fe0724bEb5ed04c7/af1178dbdfa9f313.png"
                                        alt=""
                                        />
                                    </div>
                                    )}
                                </div>
                                <div style={{ marginTop: '5px', fontSize: '10px' }}>
                                咚咚客服推荐
                                </div>
                                </div>
                            </div>
                            </div>
                        )}
                        {+item.smsContent.type == 1 && item.smsContent.tplData.showType == 2 && (
                            <div className={styles.textContainer}>
                            <div className={styles.textDate}>
                                <span>10月20日</span>
                            </div>
                            <div className={styles.textContext}>
                                <img className={styles.textHead} src={head} />
                                <div className={styles.textRight}>
                                <div className={styles.textName}>XXX客服</div>
                                <div className={styles.textCardContext}>
                                    <div className={styles.textCardTitle}>
                                    {item.smsContent.tplData.title || '标题'}
                                    </div>
                                    <div className={styles.textCardmain}>
                                    {item.smsContent.tplData.message || '邀请语'}
                                    </div>
                                    <div
                                    style={{ display: 'flex', flexDirection: 'column' }}
                                    >
                                    {item.smsContent.tplData.data.length > 0 &&
                                        item.smsContent.tplData.data.map((item, index) => (
                                        <div
                                            key={index}
                                            style={{
                                            borderTop: '1px solid #E3E8EE',
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingTop: '8px',
                                            marginTop: '8px',
                                            }}
                                        >
                                            <img
                                            style={{ height: 50 }}
                                            src={item.imagePath}
                                            alt=""
                                            />
                                            <div
                                            style={{ height: 50, paddingLeft: '5px' }}
                                            >
                                            <div className={styles.textOverflow2}>
                                                {item.name}
                                            </div>
                                            <div style={{ marginTop: '6px' }}>
                                                {/* ¥{(+item.price).toFixed(2)} */}
                                                ¥{item.price}
                                            </div>
                                            </div>
                                        </div>
                                        ))}
                                    </div>
                                    {item.smsContent.tplData.bottomBtnType === '1' && (
                                    <div
                                        style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginTop: '10px',
                                        }}
                                    >
                                        <span style={{ marginRight: '5px' }}>
                                        查看更多
                                        </span>
                                        <img
                                        src="//img10.360buyimg.com/imgzone/jfs/t1/145928/2/19396/367/5fe0724bEb5ed04c7/af1178dbdfa9f313.png"
                                        alt=""
                                        />
                                    </div>
                                    )}
                                </div>
                                <div style={{ marginTop: '5px', fontSize: '10px' }}>
                                咚咚客服推荐
                                </div>
                                </div>
                            </div>
                            </div>
                        )}
                        {/* 圖文消息手机效果 */}
                        {+item.smsContent.type === 2 && item.smsContent.tplData.style === 'imageTop' && (
                            <div className={styles.textContainer}>
                            <div className={styles.textDate}>
                                <span>10月20日</span>
                            </div>
                            <div className={styles.textContext}>
                                <img className={styles.textHead} src={head} />
                                <div className={styles.textRight}>
                                <div className={styles.textName}>XXX客服</div>
                                <div className={styles.imgTextContext}>
                                    <img
                                    style={{
                                        width: '100%',
                                        height: 80,
                                        borderTopLeftRadius: '5px',
                                        borderTopRightRadius: '5px',
                                    }}
                                    src={item.smsContent.tplData.image || imgAuto[0]}
                                    alt=""
                                    />
                                    <div
                                    style={{
                                        padding: '13px 10px',
                                        backgroundColor: '#fff',
                                        borderBottomLeftRadius: '5px',
                                        borderBottomRightRadius: '5px',
                                    }}
                                    >
                                    <div className={styles.textCardTitle}>
                                        {item.smsContent.tplData.title || '标题'}
                                    </div>
                                    <div style={{ marginTop: '4px' }}>
                                        {item.smsContent.tplData.message || '描述'}
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        )}
                        {+item.smsContent.type === 2 && item.smsContent.tplData.style === 'normal' && (
                            <div className={styles.textContainer}>
                            <div className={styles.textDate}>
                                <span>10月20日</span>
                            </div>
                            <div className={styles.textContext}>
                                <img className={styles.textHead} src={head} />
                                <div className={styles.textRight}>
                                <div className={styles.textName}>XXX客服</div>
                                <div className={styles.textCardContext}>
                                    <div className={styles.textCardTitle}>
                                    {item.smsContent.tplData.title || '标题'}
                                    </div>
                                    <div style={{ display: 'flex', marginTop: '10px' }}>
                                    <img
                                        style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: '5px',
                                        }}
                                        src={item.smsContent.tplData.image || imgAuto[1]}
                                        alt=""
                                    />
                                    <div style={{ flex: '1', padding: '0 10px' }}>
                                        {item.smsContent.tplData.message || '描述'}
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        )}
                        </div>
                    </div>

                </Balloon>
              ) : (
                <div>{item.smsContent ? item.smsContent : '/'}</div>
              )
            }
            width="250px"
          />
          <Table.Column
            align="left"
            title="字数/计费（条）"
            cell={(value, index, item) =>
              item.taskType === 4 ? (
                <div>{item.smsSplitNum}</div>
              ) : (
                <div>/</div>
              )
            }
            width="100px"
          />
          {/* <Table.Column
            align="left"
            title="操作"
            width="100px"
            lock="right"
            cell={(value, index, item) => (
              <div>
                <Button
                  type="primary"
                  text
                  onClick={() => {
                    dataExport([item.taskInstId]);
                  }}
                  // disabled={item.packStatus !== 104}
                >
                  导出
                </Button>
                &nbsp;&nbsp;
                {(item.packStatus === 3 || item.packStatus === 1) && item.pre !== 0 && item.taskType !== 1 && (
                  <Button
                    type="primary"
                    text
                    onClick={() => {
                      stopSmsSendTask(item.activityRecordId, item.taskType);
                    }}
                  >
                    停止投放
                  </Button>
                )}
                {((item.packStatus !== 3 && item.packStatus !== 1) || item.pre === 0 || item.taskType === 1) && (
                  <Button type="primary" text disabled>
                    停止投放
                  </Button>
                )}
                {
                    (+item.taskType === 4 || +item.taskType === 5) && <Button
                        type="primary"
                        style={{ marginLeft: '10px' }}
                        text
                        disabled={!(+item.packStatus === 103||+item.packStatus === 104)}
                        onClick={() => {
                        setSecondaryVisible(true);
                        setSecondaryMarketCrowdData(item);
                        }}
                    >
                        二次营销
                    </Button>
                }
              </div>
            )}
          /> */}
        </Table.StickyLock>
      </div>
      <div style={{ paddingBottom: '20px' }}>
        <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
      </div>

      {/* 生成二次营销人群弹框 */}
      <LzDialog
          visible={secondaryVisible}
          shouldUpdatePosition
          title="生成二次营销人群"
          onClose={() => {
          setSecondaryVisible(false);
          }}
          style={{
          width: '1060px',
          }}
          className={styles.crowd_second_market}
          footer={false}
          isFullScreen
      >
          {secondaryVisible && (
          <SecondaryMarketCrowd
              secondaryClose={secondaryClose}
              record={secondaryMarketCrowdData}
          />
          )}
      </LzDialog>
      {/* 批量生成二次营销人群弹窗 */}
      {
        batchSecondaryVisible &&
        <BatchSecondaryMarket
          batchSecondaryVisible = {batchSecondaryVisible}
          setBatchSecondaryVisible={(v)=>{setBatchSecondaryVisible(v)}}
          record = {checkedInfo}
        />
      }
    </div>
  );
};
